<template>
  <v-container id="recycling-ledger" fluid>
    <v-row align="center" justify="center">
			<v-col cols="12">
				<v-data-table 
					id="data-table"
					hide-default-footer					
					fixed-header
					height="55vh"					
					:headers="rlEntryTableHeaders"
					:items="getRlEntryList.data"
					:server-items-length="getRlEntryList.total"
					:options.sync="rlEntryTableOptions"
					:loading="getRlEntryTable.loading"
					loading-text="Loading Recycling Ledger Entries..."	
					:footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true}"				
					class="elevation-1"
				>					
					<template v-slot:top>	
						<v-row>	
							<v-col>				
								<v-btn color="primary" @click.prevent="openRlAddDialog()">Add Entries</v-btn>	
							</v-col>													
							<v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer /><v-spacer />
							<v-col>									
								<a href="./RecyclingLedgerImport.xlsx" class="ma-2" download >File Template</a>
							</v-col>
						</v-row>						
						<v-divider />
					</template>
								
					<template v-slot:header.entry_type="{ header }">
						{{ header.text }}
						<v-menu v-model="menu.entry_type" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="50px">
							<template v-slot:activator="{ on, attrs }">
								<v-icon :color="rlEntryTableOptions.filters.entry_type_id ? 'primary' : 'grey'" id="entry-type-filter" v-bind="attrs" v-on="on">filter_alt</v-icon>
							</template>
							<v-card id="entryType1">
								<v-card-title>
									<span>Entry Type</span>
								</v-card-title>
								<v-card-text>
									<v-select id="entryType2" v-model="rlEntryTableOptions.filters.entry_type_id" :items="getEntryTypeList" item-value="id" item-text="description" dense clearable />
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary darken-1" text @click.prevent="menu.entry_type = false">Close</v-btn>
            						<v-btn color="primary" @click.prevent="getRecyclingLedgerEntryList(), menu.entry_type = false">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>								
					</template>

					<template v-slot:header.trans_date="{ header }">		
						{{ header.text }}			
						<v-menu v-model="menu.trans_date" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="50px">
							<template v-slot:activator="{ on, attrs }">
								<v-icon :color="filterTransDate1 || filterTransDate2 ? 'primary' : 'grey'" v-bind="attrs" v-on="on">filter_alt</v-icon>
							</template>
							<v-card>
								<v-card-title>
									<span>Transaction Date</span>
								</v-card-title>
								<v-card-text>
									<v-menu v-model="menu.trans_date1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                  				<template v-slot:activator="{ on, attrs }">
                    				<v-text-field v-model="filterTransDate1" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense clearable />
                  				</template>
                					<v-date-picker v-model="filterTransDate1" @input="menu.trans_date1 = false" />
									</v-menu>
									<v-spacer />
									<v-menu v-model="menu.trans_date2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field v-model="filterTransDate2" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense clearable />
										</template>
                						<v-date-picker v-model="filterTransDate2" @input="menu.trans_date2 = false" />
              						</v-menu>
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary darken-1" text @click.prevent="menu.trans_date = false">Close</v-btn>
            					<v-btn color="primary" @click.prevent="setTransDate(), getRecyclingLedgerEntryList(), menu.trans_date = false">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>
					</template>

					<template v-slot:header.coll_dest_company="{ header }">
						{{ header.text }}
						<v-menu v-model="menu.coll_dest_company" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="50px">
							<template v-slot:activator="{ on, attrs }">
								<v-icon :color="rlEntryTableOptions.filters.coll_dest_company ? 'primary' : 'grey'" v-bind="attrs" v-on="on">filter_alt</v-icon>
							</template>
							<v-card>
								<v-card-title>
									<span>Company Name</span>
								</v-card-title>
								<v-card-text>
									<v-select v-model="rlEntryTableOptions.filters.coll_dest_company" :items="getCompanyList" item-value="coll_dest_company" item-text="coll_dest_company" dense clearable />
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary darken-1" text @click.prevent="menu.coll_dest_company = false">Close</v-btn>
            						<v-btn color="primary" @click.prevent="getRecyclingLedgerEntryList(), menu.coll_dest_company = false">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>								
					</template>

					<template v-slot:header.coll_dest_country="{ header }">
						{{ header.text }}
						<v-menu v-model="menu.coll_dest_country" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="50px">
							<template v-slot:activator="{ on, attrs }">
								<v-icon :color="rlEntryTableOptions.filters.coll_dest_country ? 'primary' : 'grey'" id="entry-type-filter" v-bind="attrs" v-on="on">filter_alt</v-icon>
							</template>
							<v-card>
								<v-card-title>
									<span>Company Country</span>
								</v-card-title>
								<v-card-text>
									<v-select v-model="rlEntryTableOptions.filters.coll_dest_country" :items="getCountryList" item-value="code" item-text="name" dense clearable />
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary darken-1" text @click.prevent="menu.coll_dest_country = false">Close</v-btn>
            						<v-btn color="primary" @click.prevent="getRecyclingLedgerEntryList(), menu.coll_dest_country= false">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>								
					</template>

					<template v-slot:header.coll_dest_city="{ header }">
						{{ header.text }}
						<v-menu v-model="menu.coll_dest_city" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="50px">
							<template v-slot:activator="{ on, attrs }">
								<v-icon :color="rlEntryTableOptions.filters.coll_dest_city ? 'primary' : 'grey'" id="entry-type-filter" v-bind="attrs" v-on="on">filter_alt</v-icon>
							</template>
							<v-card>
								<v-card-title>
									<span>Company City</span>
								</v-card-title>
								<v-card-text>
									<v-select v-model="rlEntryTableOptions.filters.coll_dest_city" :items="getCompanyList" item-value="coll_dest_city" item-text="coll_dest_city" dense clearable />
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary darken-1" text @click.prevent="menu.coll_dest_city = false">Close</v-btn>
            						<v-btn color="primary" @click.prevent="getRecyclingLedgerEntryList(), menu.coll_dest_city = false">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>								
					</template>

					<template v-slot:header.material ="{ header }">
						{{ header.text }}
						<v-menu v-model="menu.material " :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="50px">
							<template v-slot:activator="{ on, attrs }">
								<v-icon :color="rlEntryTableOptions.filters.material_id ? 'primary' : 'grey'" id="entry-type-filter" v-bind="attrs" v-on="on">filter_alt</v-icon>
							</template>
							<v-card>
								<v-card-title>
									<span>Material Type</span>
								</v-card-title>
								<v-card-text>
									<v-select v-model="rlEntryTableOptions.filters.material_id " :items="getMaterialList" item-value="id" item-text="description" dense clearable />
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary darken-1" text @click.prevent="menu.material = false">Close</v-btn>
            						<v-btn color="primary" @click.prevent="getRecyclingLedgerEntryList(), menu.material = false">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>								
					</template>

					<template v-slot:header.grade ="{ header }">
						{{ header.text }}
						<v-menu v-model="menu.grade " :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="50px">
							<template v-slot:activator="{ on, attrs }">
								<v-icon :color="rlEntryTableOptions.filters.grade_id ? 'primary' : 'grey'" id="entry-type-filter" v-bind="attrs" v-on="on">filter_alt</v-icon>
							</template>
							<v-card>
								<v-card-title>
									<span>Grade Type</span>
								</v-card-title>
								<v-card-text>
									<v-select v-model="rlEntryTableOptions.filters.grade_id " :items="getGradeList" item-value="id" item-text="description" dense clearable />
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary darken-1" text @click.prevent="menu.grade = false">Close</v-btn>
            						<v-btn color="primary" @click.prevent="getRecyclingLedgerEntryList(), menu.grade = false">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>								
					</template>

					<template v-slot:header.dom_haul_company ="{ header }">
						{{ header.text }}
						<v-menu v-model="menu.dom_haul_company " :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="50px">
							<template v-slot:activator="{ on, attrs }">
								<v-icon :color="rlEntryTableOptions.filters.dom_haul_company ? 'primary' : 'grey'" id="entry-type-filter" v-bind="attrs" v-on="on">filter_alt</v-icon>
							</template>
							<v-card>
								<v-card-title>
									<span>Domestic Haulage Company</span>
								</v-card-title>
								<v-card-text>
									<v-select v-model="rlEntryTableOptions.filters.dom_haul_company " :items="getDomesticCompanyList" item-value="dom_haul_company" item-text="dom_haul_company" dense clearable />
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary darken-1" text @click.prevent="menu.dom_haul_company = false">Close</v-btn>
            						<v-btn color="primary" @click.prevent="getRecyclingLedgerEntryList(), menu.dom_haul_company = false">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>								
					</template>

					<template v-slot:header.int_ship_company ="{ header }">
						{{ header.text }}
						<v-menu v-model="menu.int_ship_company " :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="50px">
							<template v-slot:activator="{ on, attrs }">
								<v-icon :color="rlEntryTableOptions.filters.int_ship_company ? 'primary' : 'grey'" id="entry-type-filter" v-bind="attrs" v-on="on">filter_alt</v-icon>
							</template>
							<v-card>
								<v-card-title>
									<span>International Shipping Company</span>
								</v-card-title>
								<v-card-text>
									<v-select v-model="rlEntryTableOptions.filters.int_ship_company " :items="getShippingCompanyList" item-value="int_ship_company" item-text="int_ship_company" dense clearable />
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary darken-1" text @click.prevent="menu.int_ship_company = false">Close</v-btn>
            						<v-btn color="primary" @click.prevent="getRecyclingLedgerEntryList(), menu.int_ship_company = false">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>								
					</template>

					<template v-slot:header.hs2 ="{ header }">
						{{ header.text }}
						<v-menu v-model="menu.hs2 " :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="50px">
							<template v-slot:activator="{ on, attrs }">
								<v-icon :color="rlEntryTableOptions.filters.hs2 ? 'primary' : 'grey'" id="entry-type-filter" v-bind="attrs" v-on="on">filter_alt</v-icon>
							</template>
							<v-card>
								<v-card-title>
									<span>HS2</span>
								</v-card-title>
								<v-card-text>
									<v-select v-model="rlEntryTableOptions.filters.hs2 " :items="getHs2List" item-value="hs2" item-text="hs2" dense clearable />
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary darken-1" text @click.prevent="menu.hs2 = false">Close</v-btn>
            						<v-btn color="primary" @click.prevent="getRecyclingLedgerEntryList(), menu.hs2 = false">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>								
					</template>

					<template v-slot:header.insp_company ="{ header }">
						{{ header.text }}
						<v-menu v-model="menu.insp_company " :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="50px">
							<template v-slot:activator="{ on, attrs }">
								<v-icon :color="rlEntryTableOptions.filters.insp_company ? 'primary' : 'grey'" id="entry-type-filter" v-bind="attrs" v-on="on">filter_alt</v-icon>
							</template>
							<v-card>
								<v-card-title>
									<span>Inspection Company</span>
								</v-card-title>
								<v-card-text>
									<v-select v-model="rlEntryTableOptions.filters.insp_company " :items="getInspectionCompanyList" item-value="insp_company" item-text="insp_company" dense clearable />
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary darken-1" text @click.prevent="menu.insp_company = false">Close</v-btn>
            						<v-btn color="primary" @click.prevent="getRecyclingLedgerEntryList(), menu.insp_company = false">OK</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>								
					</template>

					<template v-slot:item.coll_dest_country="{ item }">
						{{ getCountryByCode(item.coll_dest_country) }}
					</template>

					<template v-slot:item.material_volume="{ item }">
						<v-container fluid>
						<v-row align="center" justify="center" align-content="end" dense>
							<v-col cols="7">{{ item.material_volume }}</v-col>
							<v-col cols="5"><v-chip class="ma-2" label>{{ item.material_uom }}</v-chip></v-col>						
						</v-row>
						</v-container>
					</template>

					<template v-slot:item.material_unit_price="{ item }">
						<v-row align="center" justify="center" dense>
							<v-col cols="5"><v-chip class="ma-2" label>{{ item.material_unit_price_cc }}</v-chip></v-col>
							<v-col cols="7">{{ item.material_unit_price }}</v-col>
						</v-row>
					</template>

					<template v-slot:item.PRN_PERN_price="{ item }">
						<v-row align="center" justify="center" dense>
							<v-col cols="5"><v-chip v-if="item.PRN_PERN_price_cc" class="ma-2" label>{{ item.PRN_PERN_price_cc }}</v-chip></v-col>
							<v-col cols="7">{{ item.PRN_PERN_price }}</v-col>
						</v-row>
					</template>

					<template v-slot:item.dom_haul_cost="{ item }">
						<v-row align="center" justify="center" dense>
							<v-col cols="5"><v-chip v-if="item.dom_haul_cost_cc" class="ma-2" label>{{ item.dom_haul_cost_cc }}</v-chip></v-col>
							<v-col cols="7">{{ item.dom_haul_cost }}</v-col>
						</v-row>
					</template>

					<template v-slot:item.dom_haul_booked="{ item }">
						<v-switch class="ma-2" v-model="item.dom_haul_booked" disabled />
					</template>

					<template v-slot:item.int_ship_cost="{ item }">
						<v-row align="center" justify="center" dense>
							<v-col cols="5"><v-chip v-if="item.int_ship_cost_cc" class="ma-2" label>{{ item.int_ship_cost_cc }}</v-chip></v-col>
							<v-col cols="7">{{ item.int_ship_cost }}</v-col>
						</v-row>
					</template>

					<template v-slot:item.int_ship_booked="{ item }">
						<v-switch class="ma-2" v-model="item.int_ship_booked" disabled />
					</template>

					<template v-slot:item.insurance_cost="{ item }">
						<v-row align="center" justify="center" dense>
							<v-col cols="5"><v-chip v-if="item.insurance_cost_cc" class="ma-2" label>{{ item.insurance_cost_cc }}</v-chip></v-col>
							<v-col cols="7">{{ item.insurance_cost }}</v-col>
						</v-row>
					</template>

					<template v-slot:item.insp_cost="{ item }">
						<v-row align="center" justify="center" dense>
							<v-col cols="5"><v-chip v-if="item.insp_cost_cc" class="ma-2" label>{{ item.insp_cost_cc }}</v-chip></v-col>
							<v-col cols="7">{{ item.insp_cost }}</v-col>
						</v-row>
					</template>

					<template v-slot:item.FX_rate="{ item }">
						<v-row align="center" justify="center" dense>
							<v-col cols="5"><v-chip v-if="item.FX_cc" class="ma-2" label>{{ item.FX_cc }}</v-chip></v-col>
							<v-col cols="7">{{ item.FX_rate }}</v-col>
						</v-row>
					</template>

					<template v-slot:item.other_costs="{ item }">
						<v-row align="center" justify="center" dense>
							<v-col cols="5"><v-chip v-if="item.other_costs_cc" class="ma-2" label>{{ item.other_costs_cc }}</v-chip></v-col>
							<v-col cols="7">{{ item.other_costs }}</v-col>
						</v-row>
					</template>

					<template v-slot:item.notes="{ item }">													
						<v-icon :color="item.notes ? 'green' : ''" @click.prevent="openRlEditNote(item)">speaker_notes</v-icon>						
					</template>

					<template v-slot:item.pictures="{ item }">
						<v-badge :content="item.images.data.length" :value="item.images.data.length" color="green" left overlap>
							<v-icon @click.prevent="openRlImagesEditDialog(item)">insert_photo</v-icon>
						</v-badge>
        			</template>

					<template v-slot:item.actions="{ item }">					
						<v-icon @click.prevent="openRlDeleteDialog(item)">delete</v-icon>
						<v-icon @click.prevent="openRlEditDialog(item)">edit</v-icon>		
					</template>					
				</v-data-table>
			<v-layout row justify-center>             
              <v-row justify="end" align="end" align-content="end" dense>                 
            	<v-col cols="4" >
                    <v-pagination
						light
						v-model="page"
						:length="Math.ceil(getRlEntryList.total/rlEntryTableOptions.itemsPerPage)"
						@input="next"
					/>					
                </v-col>
              </v-row>                   
            </v-layout>      
				<rl-add-dialog /> 

				<rl-edit-dialog />
				
				<rl-delete-dialog />

				<rl-image-edit-dialog />

				<rl-edit-note />	

				<add-dialog-slim-view />
		</v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import RlAddDialog from '../components/recyclingLedgerEntry/AddDialog.vue'
import RlEditDialog from '../components/recyclingLedgerEntry/EditDialog.vue'
import RlDeleteDialog from '../components/recyclingLedgerEntry/DeleteDialog.vue'
import RlImageEditDialog from '../components/recyclingLedgerEntryImage/EditDialog.vue'
import RlEditNote from '../components/recyclingLedgerEntryNote/EditDialog.vue'
import AddDialogSlimView from '../components/recyclingLedgerEntry/AddDialogSlimView.vue'

export default {
	name: 'RecyclingLedger',
	components: {
		RlAddDialog: RlAddDialog,
		RlEditDialog: RlEditDialog,
		RlDeleteDialog: RlDeleteDialog,
		RlImageEditDialog: RlImageEditDialog,
		RlEditNote: RlEditNote,	
		AddDialogSlimView: AddDialogSlimView,			
	},
	data() {
		return {				
			page: 1,					
			menu: {},		
			rlEntryTableHeaders: [			
				{text: 'Entry Type', value: 'entry_type', width: 150},
				{text: 'Transaction Date', value: 'trans_date', width: 200},
				{text: 'Collection/Destination Company Name', value: 'coll_dest_company', width: 200},
				{text: 'Collection/Destination Country', value: 'coll_dest_country', width: 200},
				{text: 'Collection/Destination City', value: 'coll_dest_city', width: 200},
				{text: 'Collection/Destination Address', value: 'coll_dest_address', width: 200},
				{text: 'Collection/Destination Contact Name', value: 'coll_dest_contact_name', width: 200},
				{text: 'Collection/Destination Contact Tel', value: 'coll_dest_contact_tel', width: 200},
				{text: 'Collection/Destination Contact Email', value: 'coll_dest_contact_email', width: 200},
    		    {text: 'Material', value: 'material', width: 200},
				{text: 'Grade', value: 'grade', width: 200},
				{text: 'Specification', value: 'spec', width: 150},
				{text: 'Contamination Percentage', value: 'cont_perc', width: 100},
				{text: 'Material Volume', value: 'material_volume', width: 240},
				{text: 'Material Unit Price', value: 'material_unit_price', width: 240},
				{text: 'Incoterm', value: 'incoterm', width: 200},
				{text: 'PRN/PERN Price', value: 'PRN_PERN_price', width: 200},				
				{text: 'Domestic Haulage Cost', value: 'dom_haul_cost', width: 200},
				{text: 'Domestic Haulage Company', value: 'dom_haul_company', width: 250},
				{text: 'Domestic Haulage Booked', value: 'dom_haul_booked', width: 150},
				{text: 'Domestic Haulage Collection Date', value: 'dom_haul_date', width: 200},
				{text: 'International Shipping Cost', value: 'int_ship_cost', width: 200},
				{text: 'International Shipping Company', value: 'int_ship_company', width: 200},
				{text: 'International Shipping Booked', value: 'int_ship_booked', width: 150},
				{text: 'International Shipping Collection Date', value: 'int_ship_date', width: 200},
				{text: 'Insurance Cost', value: 'insurance_cost', width: 200},
				{text: 'HS2', value: 'hs2', width: 150},
				{text: 'Inspection Company', value: 'insp_company', width: 200},
				{text: 'Inspection Cost', value: 'insp_cost', width: 200},
				{text: 'FX Rate', value: 'FX_rate', width: 200},
				{text: 'Other Costs Description', value: 'other_costs_desc', width: 200},
				{text: 'Other Costs', value: 'other_costs', width: 200},
				{text: 'Notes', value: 'notes', sortable: false, width: 100},
				{text: 'Pictures', value: 'pictures', sortable: false, width: 100},
      	{text: 'Actions', value: 'actions', sortable: false, width: 200},
				
			],
			rlEntryTableOptions: {
				page: 1,
				itemsPerPage: 10,
				sortBy: ['trans_date'],
				sortDesc: [true],
				filters: {}
			},
			filterTransDate1: null,
			filterTransDate2: null,
		}
	},
	watch: {	
		rlEntryTableOptions: {
			handler() {
				this.getRecyclingLedgerEntryList()
			},			
		},
		deep: true
	},
	mounted() {
		this.setEntryTypeList()
		this.setMaterialList()
		this.setGradeList()
		this.setIncotermList()
		this.setCurrencyList()
		this.setCountryList()
		this.setUnitOfMeasureList()
		this.setCompanyList()
	},
	methods: {	
		next(){					
			this.$set(this.rlEntryTableOptions, 'page', this.page )
			this.getRecyclingLedgerEntryList()
		},		
		getRecyclingLedgerEntryList() {
			window.scrollTo(0,0)
			this.setRlEntryTableOptions(this.rlEntryTableOptions)
			this.setRlEntryList()
		},	
		openRlEditNote(item, isScroll) {
			this.setRlEntry((({id, entry_type_id, trans_date, material_id, grade_id, spec, cont_perc, material_volume, material_uom, material_unit_price_cc, material_unit_price, incoterm_id, PRN_PERN_price_cc, PRN_PERN_price, coll_dest_company, coll_dest_country, coll_dest_city, coll_dest_address, coll_dest_contact_name, coll_dest_contact_tel, coll_dest_contact_email, dom_haul_cost_cc, dom_haul_cost, dom_haul_company, dom_haul_booked, dom_haul_date, int_ship_cost, int_ship_cost_cc, int_ship_company, int_ship_booked, int_ship_date, insurance_cost_cc, insurance_cost, hs2, insp_company, insp_cost_cc, insp_cost, FX_cc, FX_rate, other_costs_desc, other_costs_cc, other_costs, notes}) => ({id, entry_type_id, trans_date, material_id, grade_id, spec, cont_perc, material_volume, material_uom, material_unit_price_cc,  material_unit_price, incoterm_id, PRN_PERN_price_cc, PRN_PERN_price, coll_dest_company, coll_dest_country, coll_dest_city, coll_dest_address, coll_dest_contact_name, coll_dest_contact_tel, coll_dest_contact_email, dom_haul_cost_cc, dom_haul_cost, dom_haul_company, dom_haul_booked, dom_haul_date, int_ship_cost, int_ship_cost_cc, int_ship_company, int_ship_booked, int_ship_date, insurance_cost_cc, insurance_cost, hs2, insp_company, insp_cost_cc, insp_cost, FX_cc, FX_rate, other_costs_desc, other_costs_cc, other_costs, notes}))(JSON.parse(JSON.stringify(item))))
			this.setRlEditNote({show: true, alert: {show: false, type: null, icon: null, message: null}, isScroll: isScroll})
		},
		openRlAddDialog() {
			this.setCompanyList()
			this.setRlAddDialog({show: true, alert: {show: false, type: null, icon: null, message: null}})
		},
		openRlEditDialog(item, isScroll) {
			this.setRlEntry((({id, entry_type_id, trans_date, material_id, grade_id, spec, cont_perc, material_volume, material_uom, material_unit_price_cc, material_unit_price, incoterm_id, PRN_PERN_price_cc, PRN_PERN_price, coll_dest_company, coll_dest_country, coll_dest_city, coll_dest_address, coll_dest_contact_name, coll_dest_contact_tel, coll_dest_contact_email, dom_haul_cost_cc, dom_haul_cost, dom_haul_company, dom_haul_booked, dom_haul_date, int_ship_cost, int_ship_cost_cc, int_ship_company, int_ship_booked, int_ship_date, insurance_cost_cc, insurance_cost, hs2, insp_company, insp_cost_cc, insp_cost, FX_cc, FX_rate, other_costs_desc, other_costs_cc, other_costs, notes}) => ({id, entry_type_id, trans_date, material_id, grade_id, spec, cont_perc, material_volume, material_uom, material_unit_price_cc,  material_unit_price, incoterm_id, PRN_PERN_price_cc, PRN_PERN_price, coll_dest_company, coll_dest_country, coll_dest_city, coll_dest_address, coll_dest_contact_name, coll_dest_contact_tel, coll_dest_contact_email, dom_haul_cost_cc, dom_haul_cost, dom_haul_company, dom_haul_booked, dom_haul_date, int_ship_cost, int_ship_cost_cc, int_ship_company, int_ship_booked, int_ship_date, insurance_cost_cc, insurance_cost, hs2, insp_company, insp_cost_cc, insp_cost, FX_cc, FX_rate, other_costs_desc, other_costs_cc, other_costs, notes}))(JSON.parse(JSON.stringify(item))))
			this.setRlEditDialog({show: true, alert: {show: false, type: null, icon: null, message: null}, isScroll: isScroll})
		},
		openRlDeleteDialog(item) {
			this.setRlEntry((({id}) => ({id}))(JSON.parse(JSON.stringify(item))))
			this.setRlDeleteDialog({show: true, alert: {show: false, type: null, icon: null, message: null}})
		},
		async openRlImagesEditDialog(item) {			
			this.setRlEntry((({images}) => ({images}))(JSON.parse(JSON.stringify(item))))			
			try {			
				const response = await axios.get('/api/v1/recyclingLedgerEntries/'+item.id+'/images')								
				this.setRlImageEditDialog({show: true, alert: {show: false, type: null, icon: null, message: null}, entryId: item.id, images: response.data.data})		
			} catch (error) {
				this.setRlImageEditDialog({show: true, alert: {show: true, type: "error", icon: "error", message: "Couldn't load the images."}})
			}
		},
		setTransDate() {
			if (this.filterTransDate1 && this.filterTransDate2) {
				this.rlEntryTableOptions.filters.trans_date = this.filterTransDate1 + ',' + this.filterTransDate2
			}   
			else if (this.filterTransDate2) {
				this.rlEntryTableOptions.filters.trans_date = ',' + this.filterTransDate2
			}   
			else if (this.filterTransDate1) {  
				this.rlEntryTableOptions.filters.trans_date = this.filterTransDate1 + ','
			}
			else {
				this.rlEntryTableOptions.filters.trans_date = null
			}
		},		
		getCountryByCode(code) {	
			if(code){					
				let name = this.getCountryList.find(x => x.code === code).name
				if(name){
					return name
				}else{
					return []
				}
			}		 
		}, 
		...mapActions([			
			'setRlEditNote',			
			'setRlEntry',
			'setRlEntryList',
			'setRlEntryTableOptions',
			'setRlAddDialog',
			'setRlEditDialog',
			'setRlDeleteDialog',
			'setRlImageEditDialog',
			'setEntryTypeList',
			'setUnitOfMeasureList',
			'setCurrencyList',
			'setCountryList',
			'setIncotermList',
			'setGradeList',
			'setMaterialList',
			'setCompanyList',
			'setDomesticCompanyList'
		])
	},
	computed: {
		...mapGetters([			
			'getRlAddDialogList',
			'getRlEntry',
			'getRlEntryList',
			'getRlEntryTable',
			'getRlImageEditDialog',
			'getEntryTypeList',
			'getCompanyList',
			'getCountryList',
			'getMaterialList',
			'getGradeList',
			'getDomesticCompanyList',
			'getShippingCompanyList',
			'getHs2List',
			'getInspectionCompanyList'
		])
  }
}
</script>

